export default {
      id: "age18plus-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite.svg#age18plus",
      toString: function () {
        return this.url;
      }
    }